var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkingDefaultIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75163 14.3282L5.98948 14.521C5.12514 14.7396 4.43382 15.3871 4.1591 16.2353L2.90352 20.1121C2.62952 20.958 2.81037 21.8854 3.38212 22.5663L4.00955 23.3136",
    stroke: "#00ADEF",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9378 23.3136L22.5652 22.5663C23.1369 21.8854 23.3178 20.958 23.0438 20.1121L21.7882 16.2353C21.5134 15.3871 20.8221 14.7396 19.9578 14.5211L19.1957 14.3283",
    stroke: "#00ADEF",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1041 25H1.84324C1.37753 25 1 24.6225 1 24.1568C1 23.6911 1.37753 23.3136 1.84324 23.3136H24.1041C24.5698 23.3136 24.9473 23.6911 24.9473 24.1568C24.9473 24.6225 24.5698 25 24.1041 25Z",
    stroke: "#00ADEF",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60663 18.7244V21.9381",
    stroke: "#00ADEF",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3407 21.9381V14.8872C19.3407 14.2521 18.8258 13.7371 18.1906 13.7371H7.75674C7.12154 13.7371 6.60663 14.2521 6.60663 14.8872V17.0322",
    stroke: "#00ADEF",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9636 11.1338L10.7264 12.7272C10.6706 13.1021 10.395 13.4067 10.0276 13.4996L9.08862 13.7371",
    stroke: "#00ADEF",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8587 13.7371L15.9198 13.4996C15.5523 13.4067 15.2767 13.1021 15.2209 12.7272L14.9837 11.1338",
    stroke: "#00ADEF",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4573 23.3136C20.7022 23.0569 20.8529 22.7095 20.8529 22.3267C20.8529 22.1121 20.6789 21.9382 20.4643 21.9382H5.48298C5.26838 21.9382 5.09439 22.1121 5.09439 22.3267C5.09439 22.7095 5.24505 23.0569 5.48998 23.3136",
    stroke: "#00ADEF",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.269 17.8775C14.269 18.5929 13.6891 19.1729 12.9736 19.1729C12.2582 19.1729 11.6783 18.5929 11.6783 17.8775C11.6783 17.1621 12.2582 16.5821 12.9736 16.5821C13.6891 16.5821 14.269 17.1621 14.269 17.8775Z",
    stroke: "#00ADEF",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.313 1.00002C12.3083 1.00002 12.3035 1.00002 12.2987 1.00007C11.5475 1.00249 10.944 1.62209 10.944 2.37329V2.39482C10.944 4.47196 12.6279 6.15582 14.705 6.15582H17.9903",
    stroke: "#00ADEF",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2438 3.86818V4.11185C11.2438 4.83378 10.6586 5.41905 9.93659 5.41905C9.55099 5.41905 9.23894 5.73255 9.24073 6.11809L9.24952 8.06108C9.24952 10.5369 11.8485 11.9195 12.9736 11.9436C14.0988 11.9195 16.6977 10.5369 16.6977 8.06108L16.7026 6.15576",
    stroke: "#00ADEF",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9893 10.1447L17.9905 5.35999C17.9926 2.95265 16.0416 1.00001 13.6342 1.00001H12.313C9.9057 1.00001 7.95474 2.95265 7.95682 5.35999L7.95899 13.7372",
    stroke: "#00ADEF",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9883 13.7371L17.9888 11.8395",
    stroke: "#00ADEF",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24089 6.15577H8.64519C8.265 6.15577 7.95682 6.46395 7.95682 6.84414V7.65782C7.95682 8.0383 8.26524 8.34677 8.64572 8.34677H9.2617",
    stroke: "#00ADEF",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6856 8.34677H17.3016C17.6821 8.34677 17.9904 8.0383 17.9904 7.65782V6.84414C17.9904 6.46395 17.6823 6.15577 17.3021 6.15577H16.7026",
    stroke: "#00ADEF",
    strokeWidth: 0.703125,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkingDefaultIc);
export default __webpack_public_path__ + "static/media/working-default-ic.f307ecccf8795957abf24b8417559662.svg";
export { ForwardRef as ReactComponent };